import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { CatalogueDrawerContent, CatalogueDrawerMask, CatalogueDrawerWrapper } from './atoms'

interface Props {
  visible: boolean
  children: React.ReactNode
  handleMaskClick?: () => void
}

export const CatalogueDrawer = ({ visible, children, handleMaskClick }: Props) => {
  const [isWindow, setIsWindow] = useState(false)
  const [drawerHeight, setDrawerHeight] = useState('100vh')

  useEffect(() => {
    setIsWindow(true)
    convertStyle()
    window.addEventListener('resize', convertStyle)
    return () => {
      window.removeEventListener('resize', convertStyle)
    }
  }, [])

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [visible])

  const convertStyle = () => {
    setDrawerHeight(`${window.innerHeight}px`)
  }

  const drawerElement = (
    <CatalogueDrawerWrapper>
      <CatalogueDrawerMask $drawerHeight={drawerHeight} onClick={() => handleMaskClick?.()} />
      <CatalogueDrawerContent $drawerHeight={drawerHeight}>{children}</CatalogueDrawerContent>
    </CatalogueDrawerWrapper>
  )

  return isWindow && visible ? ReactDOM.createPortal(drawerElement, document.body) : null
}
